var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-button',{staticClass:"mr-2",attrs:{"color":"primary","type":"border","icon-pack":"feather","icon":"preview"},on:{"click":_vm.hanldeViewSidebar}}),(_vm.addcall)?_c('add-call-history',{attrs:{"isSidebarActive":_vm.addNewCallSidebar,"leadId":_vm.leadId},on:{"closeSidebarCall":_vm.pushCall}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }